import { useMemo } from "react";
import { generatePath, Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CALENDAR_SHIFT_DAY_ROUTE, CALENDAR_SHIFT_ROUTE } from "../../../app/router/routes";
import { ChangeDayInCalendar } from "../../../features/changeDayInCalendar";
import { ShiftCalendarDay } from "../../../widgets/shiftCalendarDay";
import classes from './calendarShiftDay.module.scss'

const getDateFromParam = (dateParam?: string): Date | null => {
    const match = dateParam?.match(/^(\d{4})-(\d{2})-(\d{2})$/)

    if(!match) return null

    const year = Number(match[1])
    const month = Number(match[2])
    const day = Number(match[3])
    const date = new Date(year, month - 1, day)

    if(
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ){
        return null
    }

    return date
}

const getDateParam = (date: Date): string => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export default function CalendarShiftDayPage() {

    const {date: dateParam} = useParams<{date: string}>()
    const navigate = useNavigate()
    const location = useLocation()
    const [params] = useSearchParams()
    const date = getDateFromParam(dateParam)
    const selectedWorkTgIds = useMemo(() => params
            .getAll('work_tg_ids')
            .map(id => parseInt(id, 10))
            .filter(id => !isNaN(id) && id > 0),
        [params]
    )
    const selectedWorkTgIdStrings = useMemo(
        () => selectedWorkTgIds.map(String),
        [selectedWorkTgIds]
    )
    const shiftCalendarFilter = useMemo(
        () => ({tgAccountIds: selectedWorkTgIdStrings}),
        [selectedWorkTgIdStrings]
    )

    if(!date){
        return <Navigate to={CALENDAR_SHIFT_ROUTE.path} replace />
    }

    return (
        <section className={classes.container}>
            <section className={classes.content}>
                <ShiftCalendarDay
                    date={date}
                    tgAccountIds={selectedWorkTgIdStrings}
                    onBack={() => navigate({pathname: CALENDAR_SHIFT_ROUTE.path, search: location.search})}
                />
            </section>
            <section className={classes.calendarSticky}>
                <ChangeDayInCalendar
                    date={date}
                    shiftFilter={shiftCalendarFilter}
                    onSelectDate={nextDate => {
                        navigate({
                            pathname: generatePath(CALENDAR_SHIFT_DAY_ROUTE.path, {date: getDateParam(nextDate)}),
                            search: location.search,
                        })
                    }}
                />
            </section>
        </section>
    )
}
